import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Page } from '../models/page.model';
import { ContainerTrackingYard } from './models/container-tracking-yard.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContainerTrackingYardService {

  private readonly baseUrl = `${environment.restApiUrl}container-tracking-yards`;

  constructor(private http: HttpClient) { }

  create(yard: ContainerTrackingYard): Observable<ContainerTrackingYard> {
    return this.http.post<ContainerTrackingYard>(this.baseUrl, yard);
  }

  findById(id: number, cultureCode: string = 'en-US'): Observable<ContainerTrackingYard> {
    const headers = new HttpHeaders().set('Accept-Language', cultureCode);
    return this.http.get<ContainerTrackingYard>(`${this.baseUrl}/${id}`, { headers });
  }

  findAll(params: HttpParams, cultureCode: string = 'en-US'): Observable<Page<ContainerTrackingYard>> {
    const headers = new HttpHeaders().set('Accept-Language', cultureCode);
    return this.http.get<Page<ContainerTrackingYard>>(this.baseUrl, { params, headers });
  }

  update(id: number, yard: ContainerTrackingYard): Observable<ContainerTrackingYard> {
    return this.http.put<ContainerTrackingYard>(`${this.baseUrl}/${id}`, yard);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
